var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuGe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 13.999,
    viewBox: "0 0 8 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_59",
    "data-name": "Union 59",
    d: "M-5659-8907v-14h2.667v2.8h2.667v8.4h-2.667v2.8Zm5.333-5.6v-2.8H-5651v2.8Z",
    transform: "translate(5659 8921)",
    fill: "#15081f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGe);
export default __webpack_public_path__ + "static/media/menu-ge.68253985850d280a3e041effde54da05.svg";
export { ForwardRef as ReactComponent };